import { AssetDetailsControllerWithSuspense } from '../../asset-details';
import { NextPage } from 'next';
import { TradeControllerWithSuspense } from '../CreateTrade/MainTradeController/TradeControllerWithSuspense';
import { AssetDetailTradeWrapper } from '../../layouts/AssetDetailTradeWrapper/AssetDetailTradeWrapper';

export interface ITradeOperationpage {
  params: Promise<{
    assetId: string;
    operation: string;
    swapWith?: string;
  }>;
  searchParams: Promise<{
    swapWith?: string;
  }>;
}

const TradeOperationIndexPage: NextPage<ITradeOperationpage> = async ({
  params,
  searchParams,
}) => {
  const awaitedRouteParams = await params;

  const awaitedSearchParams = await searchParams;

  const { assetId } = awaitedRouteParams;

  return (
    <>
      <AssetDetailTradeWrapper
        hideMobile="assetElement"
        AssetDetailsContent={
          <AssetDetailsControllerWithSuspense assetId={assetId} />
        }
        TradeStateContent={
          <TradeControllerWithSuspense
            routeParams={awaitedRouteParams}
            searchParams={awaitedSearchParams}
          />
        }
      />
    </>
  );
};

export { TradeOperationIndexPage };
